"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const PopoverModalForm_1 = require("../components/PopoverModalForm");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const formatDateTime_1 = require("../../utils/formatDateTime");
const src_2 = require("@rover/ts-bootstrap/dist/src");
const DatePickerContainer = ({ date, field, device, update, removeable, label, maxDate = null, minDate = null, }) => {
    const onSelect = (handleClosePopoverModal, newDate) => {
        update(newDate
            ? `${newDate.getUTCFullYear()}-${newDate.getUTCMonth() + 1 > 9 ? `${newDate.getUTCMonth() + 1}` : `0${newDate.getUTCMonth() + 1}`}-${newDate.getUTCDate() > 9 ? newDate.getUTCDate() : `0${newDate.getUTCDate()}`}`
            : '');
        handleClosePopoverModal();
    };
    const getPopoverFormInputProps = () => {
        const format = (d) => {
            const date = d ? formatDateTime_1.formatDate(d) : new Date();
            return date.toLocaleString('en-us', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            });
        };
        return {
            id: `${field}_date_picker`,
            label,
            media: device,
            text: date ? format(date) : '',
            fieldStyle: {
                marginTop: 0,
                padding: device === 'Desktop' ? '24px 0 23px' : 0,
                minHeight: 'none',
                width: '100%',
            },
            isEditingText: false,
            textMode: removeable ? true : null,
        };
    };
    const getPopoverNavbarProps = (handleClosePopoverModal) => ({
        buttonLeftCallback: () => {
            handleClosePopoverModal();
        },
    });
    const getPopoverModalProps = (handleClosePopoverModal) => ({
        placement: 'left',
    });
    const getAddChangeButton = (text) => (React.createElement("div", { key: `${field}-add-change` },
        React.createElement(src_2.Button, { text: text, type: "regular", style: {
                innerStyle: {
                    fontSize: 17,
                },
                outerStyle: {
                    height: null,
                    lineHeight: '24px',
                },
            }, mouseDownColors: {
                active: src_2.turquoise,
                inactive: src_2.aquamarine,
            } })));
    const PopoverModalChild = ({ handleSaveChange, key }) => {
        return (React.createElement("div", { key: key, style: {
                width: device === 'Mobile' ? '100%' : 360,
            } },
            React.createElement(src_1.DatePicker, { onSelect: handleSaveChange, defaultDate: new Date(formatDateTime_1.formatDate(date)), maxDate: maxDate, minDate: minDate })));
    };
    return (React.createElement(PopoverModalForm_1.default, { popoverFormInputProps: getPopoverFormInputProps(), presentationType: device !== 'Mobile' ? 'popover' : 'modal', field: field, popoverModalProps: getPopoverModalProps, popoverNavbarProps: getPopoverNavbarProps, addButton: device === 'Desktop' ? (getAddChangeButton('Add')) : (React.createElement(src_2.PlusIcon, { key: `${field}-add-change`, fill: src_2.titanium })), editButton: device === 'Desktop' ? (getAddChangeButton('Change')) : (React.createElement(src_2.ChangeIcon, { key: `${field}-add-change`, fill: src_2.titanium })), handleSaveChange: onSelect },
        React.createElement(PopoverModalChild, null)));
};
exports.default = DatePickerContainer;
